
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-management",
      function () {
        return require("private-next-pages/service-management/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-management"])
      });
    }
  